import { CheckboxPlayground } from "../CheckboxPlayground";
import { PickerPlayground } from "../PickerPlayground";
import { RadioPlayground } from "../RadioPlayground";
import { SectionedCheckboxTablePlayground } from "../SectionedCheckboxTablePlayground";
import { SelectableCardsPlayground } from "../SelectableCardsPlayground";
import { SwitchPlayground } from "../SwitchPlayground";
import { ToggleGroupPlayground } from "../ToggleGroupPlayground";
import type { PlaygroundComponentEntry } from "../playgroundComponents";

export const selectionEntries: PlaygroundComponentEntry[] = [
    {
        id: "switch",
        label: "Switch",
        description:
            "Base UI switch with a full state matrix, both sizes, loading, label placement, and static indicators.",
        group: "ready-components",
        render: () => <SwitchPlayground />,
    },
    {
        id: "toggle-group",
        label: "Toggle group",
        description:
            "Base UI single-select toggle group with sizes and disabled items.",
        group: "components",
        render: () => <ToggleGroupPlayground />,
    },
    {
        id: "radio",
        label: "Radio",
        description:
            "Base UI radio group with a full state matrix, labels, and disabled options.",
        group: "ready-components",
        render: () => <RadioPlayground />,
    },
    {
        id: "picker",
        label: "Picker",
        description:
            "Unified select / combobox / menu family on Base UI, aligned with the Figma _Select anatomy.",
        group: "ready-components",
        render: () => <PickerPlayground />,
    },
    {
        id: "checkbox",
        label: "Checkbox",
        description:
            "Base UI checkbox with a full state matrix, group selection, and static indicators.",
        group: "ready-components",
        render: () => <CheckboxPlayground />,
    },
    {
        id: "sectioned-checkbox-table",
        label: "Sectioned checkbox table",
        description: "Grouped checkbox rows with section select-all.",
        group: "components",
        render: () => <SectionedCheckboxTablePlayground />,
    },
    {
        id: "selectable-cards",
        label: "Selectable cards",
        description: "Card-style selectable options.",
        group: "components",
        render: () => <SelectableCardsPlayground />,
    },
];
